import React, { useState, useEffect } from "react";
import "../../styles/clients.scss";
import { getUserType, setLocalStorage } from "../../../helpers/common";
import { AGENT_INTRODUCTION, MEMBER_INTRODUCTION } from "../../../constants/common";
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { CUSTOMIZE_INTRO } from "../../../constants/onBoarding";


const ReOrderFeatures = (props) => {
    const { selectedProperty } = props

    useEffect(() => {

        document.body.classList.add('bg-offcanvas-fix');

    }, []);

    const userType = getUserType();

    let session = userType == 2 ? AGENT_INTRODUCTION : MEMBER_INTRODUCTION;

    const [selectedDatas, setSelectedDatas] = useState(selectedProperty);

    const propertyFeatures = selectedProperty?.propertyFeaturesForPreview;

    const [featuredProperty, setFeaturedProperty] = useState([]);
    const [propertyFeatureReorder, setPropertyFeatureReorder] = useState(false);

    useEffect(() => {
        if (propertyFeatures && propertyFeatures.length > 0) {
            setFeaturedProperty(propertyFeatures)
        }
        else {
            setFeaturedProperty([])
        }
        setPropertyFeatureReorder(false);

    }, [propertyFeatures])

    const handleDrop =  (params) => {
        let sourceIndex = params.source.index;
        let destinationIndex = params.destination.index;
        let newPropertyFeatures = featuredProperty;
        newPropertyFeatures.splice(destinationIndex, 0 , newPropertyFeatures.splice(sourceIndex, 1) );
 
       newPropertyFeatures  = newPropertyFeatures.map(item => Array.isArray(item) ? item[0] : item);
        newPropertyFeatures = newPropertyFeatures.map((feature, index) => {
            return { ...feature, order: index + 1 };
        });

        let orderdPropertyFeature = newPropertyFeatures.sort((a, b) => a.order - b.order);

        setFeaturedProperty(orderdPropertyFeature);

        let newArray = { propertyFeaturesForPreview: [...orderdPropertyFeature] }

        setSelectedDatas(selectedDatas => ({ ...selectedDatas, ...newArray }));

    };

    useEffect(() => {
        setLocalStorage(session, selectedDatas);
    }, [selectedDatas])


    return (

        <div className="gitcha-main-wrapper my-client-wrap">

            <div className="content-wrapper content-wrapper-h-102-percent">
                <div className="inner-layout-header-new bg-white">
                    <div className="review-plan-header header-brdr-btm w-100">
                        <div className="signup-login-header-top signup-header-txt clearfix">
                            <a className="back-link-small" href={void (0)} onClick={() => { props.setUIKey(CUSTOMIZE_INTRO) }}><svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M10.1003 5.39972C10.3932 5.69262 10.3932 6.16749 10.1003 6.46038L5.31066 11.2501H20.5C20.9142 11.2501 21.25 11.5858 21.25 12.0001C21.25 12.4143 20.9142 12.7501 20.5 12.7501H5.31066L10.1003 17.5397C10.3932 17.8326 10.3932 18.3075 10.1003 18.6004C9.80744 18.8933 9.33256 18.8933 9.03967 18.6004L2.96967 12.5304C2.82902 12.3897 2.75 12.199 2.75 12.0001C2.75 11.8011 2.82902 11.6104 2.96967 11.4697L9.03967 5.39972C9.33256 5.10683 9.80744 5.10683 10.1003 5.39972Z" fill="#1B1C1E" />
                            </svg></a>
                            <span>Reorder Features</span>
                        </div>
                    </div>
                </div>
                <DragDropContext onDragEnd={(params) => { handleDrop(params) }}>
                    <div className="inner-layout-content-new">
                        <div className="reorder-wrap">
                            <h4>Drag to change the order of your property’s features for this introduction.</h4>
                            <p className="m-0">Shown from highest priority to lowest priority.</p>

                            <Droppable droppableId="features">
                                {(provided) => (
                                    <div className="features-drag-list d-flex flex-column" {...provided.droppableProps} ref={provided.innerRef}>
                                        {
                                            featuredProperty.sort((a, b) => a.order - b.order).map((feature, index) => {
                                                return(
                                               
                                                    <Draggable key={index+1} draggableId={"features-" + index} index={index}>
                                                        {(provided) => (

                                                            <div className="drag-block d-flex align-items-center"
                                                                ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}
                                                            >
                                                                <button className="drag-btn" >
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                                        <path d="M9.75 5.625C9.75 5.8475 9.68402 6.06501 9.5604 6.25002C9.43679 6.43502 9.26109 6.57922 9.05552 6.66437C8.84995 6.74951 8.62375 6.77179 8.40552 6.72838C8.1873 6.68498 7.98684 6.57783 7.82951 6.4205C7.67217 6.26316 7.56503 6.06271 7.52162 5.84448C7.47821 5.62625 7.50049 5.40005 7.58564 5.19448C7.67078 4.98891 7.81498 4.81321 7.99998 4.6896C8.18499 4.56598 8.4025 4.5 8.625 4.5C8.92337 4.5 9.20952 4.61853 9.4205 4.82951C9.63147 5.04048 9.75 5.32663 9.75 5.625ZM15.375 6.75C15.5975 6.75 15.815 6.68402 16 6.5604C16.185 6.43679 16.3292 6.26109 16.4144 6.05552C16.4995 5.84995 16.5218 5.62375 16.4784 5.40552C16.435 5.1873 16.3278 4.98684 16.1705 4.82951C16.0132 4.67217 15.8127 4.56503 15.5945 4.52162C15.3762 4.47821 15.15 4.50049 14.9445 4.58564C14.7389 4.67078 14.5632 4.81498 14.4396 4.99998C14.316 5.18499 14.25 5.4025 14.25 5.625C14.25 5.92337 14.3685 6.20952 14.5795 6.4205C14.7905 6.63147 15.0766 6.75 15.375 6.75ZM8.625 10.875C8.4025 10.875 8.18499 10.941 7.99998 11.0646C7.81498 11.1882 7.67078 11.3639 7.58564 11.5695C7.50049 11.775 7.47821 12.0012 7.52162 12.2195C7.56503 12.4377 7.67217 12.6382 7.82951 12.7955C7.98684 12.9528 8.1873 13.06 8.40552 13.1034C8.62375 13.1468 8.84995 13.1245 9.05552 13.0394C9.26109 12.9542 9.43679 12.81 9.5604 12.625C9.68402 12.44 9.75 12.2225 9.75 12C9.75 11.7016 9.63147 11.4155 9.4205 11.2045C9.20952 10.9935 8.92337 10.875 8.625 10.875ZM15.375 10.875C15.1525 10.875 14.935 10.941 14.75 11.0646C14.565 11.1882 14.4208 11.3639 14.3356 11.5695C14.2505 11.775 14.2282 12.0012 14.2716 12.2195C14.315 12.4377 14.4222 12.6382 14.5795 12.7955C14.7368 12.9528 14.9373 13.06 15.1555 13.1034C15.3738 13.1468 15.6 13.1245 15.8055 13.0394C16.0111 12.9542 16.1868 12.81 16.3104 12.625C16.434 12.44 16.5 12.2225 16.5 12C16.5 11.7016 16.3815 11.4155 16.1705 11.2045C15.9595 10.9935 15.6734 10.875 15.375 10.875ZM8.625 17.25C8.4025 17.25 8.18499 17.316 7.99998 17.4396C7.81498 17.5632 7.67078 17.7389 7.58564 17.9445C7.50049 18.15 7.47821 18.3762 7.52162 18.5945C7.56503 18.8127 7.67217 19.0132 7.82951 19.1705C7.98684 19.3278 8.1873 19.435 8.40552 19.4784C8.62375 19.5218 8.84995 19.4995 9.05552 19.4144C9.26109 19.3292 9.43679 19.185 9.5604 19C9.68402 18.815 9.75 18.5975 9.75 18.375C9.75 18.0766 9.63147 17.7905 9.4205 17.5795C9.20952 17.3685 8.92337 17.25 8.625 17.25ZM15.375 17.25C15.1525 17.25 14.935 17.316 14.75 17.4396C14.565 17.5632 14.4208 17.7389 14.3356 17.9445C14.2505 18.15 14.2282 18.3762 14.2716 18.5945C14.315 18.8127 14.4222 19.0132 14.5795 19.1705C14.7368 19.3278 14.9373 19.435 15.1555 19.4784C15.3738 19.5218 15.6 19.4995 15.8055 19.4144C16.0111 19.3292 16.1868 19.185 16.3104 19C16.434 18.815 16.5 18.5975 16.5 18.375C16.5 18.0766 16.3815 17.7905 16.1705 17.5795C15.9595 17.3685 15.6734 17.25 15.375 17.25Z" fill="#636569" />
                                                                    </svg>
                                                                </button>
                                                                <div className="feature-icon d-flex align-items-center justify-content-center">
                                                                    <img src={feature?.icon ? require("../../../images/" + feature?.icon) : ''} />
                                                                    {/* <i className="ico-lake"></i> */}
                                                                </div>
                                                                <p className="m-0">{feature?.text}</p>
                                                            </div>
                                                        )}
                                                    </Draggable>
                                                )
                                                
                                            })}

                                    </div>
                                )}
                            </Droppable>

                        </div>
                    </div>
                    </DragDropContext>
            </div>
        </div>
    );
};

export default ReOrderFeatures;
